import axios from "axios";
import { toast } from "react-toastify";
import { privacy_policy_ERROR, privacy_policy_INFO } from "../types";

export const getPrivacyPolicyData = (e) => async (dispatch) => {
  try {
    var data = new FormData();
    var config = {
      method: "get",
      headers: {},
      url: `${process.env.NEXT_PUBLIC_API_URL}/view-page?page=privacy_policy`,
      data: data,
    };
    const res = await axios(config);
    if (res.data.success) {
      dispatch({
        type: privacy_policy_INFO,
        payload: res.data,
      });
    }
  } catch (error) {
    toast.error(error.response, {
      onClose: () => location.reload(),
    });
    dispatch({
      type: privacy_policy_ERROR,
      payload: error.response,
    });
  }
};
